import { UserRole } from "@/types";

/** Admin detail URL for a user by role (seller, host, or sales agent). */
export function adminProfilePathForRole(
  userId: string,
  role: UserRole | undefined,
): string | null {
  switch (role) {
    case UserRole.SELLER:
      return `/sellers/${userId}`;
    case UserRole.HOST:
      return `/hosts/${userId}`;
    case UserRole.SALES_AGENT:
      return `/admin/sales-agents/${userId}`;
    default:
      return null;
  }
}
